import React, { useState, useEffect } from "react";
import { AuthMe } from "../lib/MyHttp";
import { Update } from "../lib/User";
import { useTranslation } from "react-i18next";
import { SearchDevice } from "../lib/Device";

const ModifyDevice = () => {
    const { t } = useTranslation();
    const [data, setData] = useState({});
    const [searchDeviceSn, setSearchDeviceSn] = useState("");

    useEffect(() => {
        AuthMe(res => {
            setData(res);
        });
    }, []);

    const clickSave = () => {
        if (data.device_sn === "" || data.device_sn !== searchDeviceSn) {
            alert(t("기기번호를 확인 해주세요."));
        }

        Update(data, res => {
            alert(t("저장을 완료 하였습니다."));
        });
    };

    const clickSearch = () => {
        if (data.device_sn === "") {
            return;
        }
        SearchDevice(
            data.device_sn,
            res => {
                if (!res.search) {
                    setSearchDeviceSn(data.device_sn);
                    alert(t("등록 가능한 장비 입니다."));
                } else if (res.user && res.user.member_no === data.member_no) {
                    setSearchDeviceSn(data.device_sn);
                    alert(t("등록 가능한 장비 입니다."));
                } else {
                    alert(t("이미 등록한 기기 입니다."));
                    data.device_sn = "";
                    setData({ ...data });
                }
            },
            res => {
                alert(t("등록이 불가능한 장비입니다."));
            }
        );
    };

    return (
        <main className="sub-contents">
            <section className="sub-top-section"></section>

            <div className="inner">
                <h2 className="sub_title">{t("기기 정보 수정")}</h2>
                <h3 className="sub_title_sm">Modify Device</h3>

                <div className="table_box">
                    <table className="tbl_join small">
                        <caption>{t("기기정보수정")}</caption>
                        <colgroup>
                            <col width="30%" />
                            <col width="70%" />
                        </colgroup>
                        <tbody>
                            {/* <tr>
                                <th>
                                    <label htmlFor="modify_device">
                                        기기이름
                                    </label>
                                </th>
                                <td>
                                    <div className="form-box">
                                        <input type="text" className="text_nor md" id="modify_device" placeholder="이름을 입력해주세요" />
                                    </div>
                                </td>
                            </tr> */}
                            <tr>
                                <th>
                                    <label htmlFor="modify_deNum">{t("기기번호")}</label>
                                </th>
                                <td>
                                    <div className="form-box">
                                        <input
                                            type="text"
                                            className="text_nor md"
                                            id="modify_deNum"
                                            placeholder=""
                                            value={data.device_sn}
                                            onChange={e => {
                                                data.device_sn = e.target.value;
                                                setData({ ...data });
                                            }}
                                        />
                                        <button type="button" className="btn_nor md line" onClick={clickSearch}>
                                            {t("검색")}
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div className="btn_bott_box">
                    <a href="/" className="btn_nor line minW">
                        {t("돌아가기")}
                    </a>
                    <a href="javascript:;" className="btn_nor orange minW" onClick={clickSave}>
                        {t("수정하기")}
                    </a>
                </div>
            </div>
        </main>
    );
};

export default ModifyDevice;
